import { PreferredProcedureDate } from '@bariendo/lib/pn-consultation-note';
import { PaymentStatusResult } from '@bariendo/lib/payment-status';
import dayjs from 'dayjs';
import { MRT_ColumnDef, MRT_RowData } from 'mantine-react-table';
import { QUEUE_EMPTY_COLOR, TwoLineCell } from '../../components/QueueCells';

interface ToScheduleRowLike extends MRT_RowData {
  paymentStatus?: PaymentStatusResult;
  preferredDate?: PreferredProcedureDate;
}

const READY_SINCE_SIZE = 96;
const PREFERRED_DATE_SIZE = 150;

const dash = <span style={{ color: QUEUE_EMPTY_COLOR }}>—</span>;

/** The day they were paid in full or approved: when the status moved to Ready to schedule (BAR-3096). */
export function readySinceColumn<Row extends ToScheduleRowLike>(): MRT_ColumnDef<Row> {
  return {
    id: 'readySince',
    header: 'Ready since',
    size: READY_SINCE_SIZE,
    accessorFn: (row) => row?.paymentStatus?.at ?? '',
    sortingFn: 'datetime',
    Cell: ({ row }) => {
      const at = row.original?.paymentStatus?.at;
      return <TwoLineCell primary={at ? dayjs(at).format('MMM D') : dash} />;
    },
  };
}

/** The date the patient agreed to on the PN consultation, else its timing, else Not given (BAR-3096). */
export function preferredDateColumn<Row extends ToScheduleRowLike>(): MRT_ColumnDef<Row> {
  return {
    id: 'preferredDate',
    header: 'Preferred date',
    size: PREFERRED_DATE_SIZE,
    enableSorting: false,
    Cell: ({ row }) => {
      const preferred = row.original?.preferredDate;
      const text = preferred?.date ? dayjs(preferred.date).format('MMM D') : preferred?.timing;
      return <TwoLineCell primary={text ?? <span style={{ color: QUEUE_EMPTY_COLOR }}>Not given</span>} />;
    },
  };
}
